import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, forwardRef, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormControl, FormBuilder, FormGroup, Validators, FormArray, NG_VALUE_ACCESSOR, NG_VALIDATORS, AbstractControl, ValidationErrors, ControlValueAccessor, Validator } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { FeesEstimate } from './fees-estimate.model';

import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { AttachmentType, ShipStatus, Languages, YesNoOptions, ShipGasType, FormMode, ServiceStatus, Service, IMOCII } from 'src/app/shared/models/enums.model';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { FeesEstimationService } from './fees-estimation.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { first } from 'rxjs/operators';
import { BsDatepickerViewMode } from 'ngx-bootstrap/datepicker/models';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { AgentService } from '../shared/services/agent.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AgentBasicInfoComponent } from '../agent-basic-info/agent-basic-info.component';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { SailDirection } from 'src/app/front-user/shared/models/sail-direction.model';
@Component({
  selector: 'app-fees-estimation-request',
  templateUrl: './fees-estimation-request.component.html',
  styleUrls: ['./fees-estimation-request.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FeesEstimationRequestComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FeesEstimationRequestComponent),
      multi: true
    }
  ]
})
export class FeesEstimationRequestComponent implements OnInit, AfterViewInit, ControlValueAccessor, Validator {
  requestStatus: number;
  feesEstimationForm: FormGroup;
  feesEstimate: FeesEstimate = new FeesEstimate();
  currencyId: number = 0;
  loading = false;
  formSubmitted = false;
  directions: SailDirection[] = [];
  PropellerTypes: GenericLookup[] = [];
  shipTypes: GenericLookup[] = [];
  militaryTypes: GenericLookup[] = [];
  shipmentTypes: GenericLookup[] = [];
  nationalities: GenericLookup[] = [];
  RequestAttachments: Attachment[] = [];
  fuelTypes: GenericLookup[] = [];
  selectedFuelTypes: GenericLookup[] = [];
  selectedFuelTypesIds: number[]= [];
  fuelTypesDropdownSettings = {};
  shipType: string;
  shipStatus = ShipStatus;
  shipStatusKeys = Object.keys(this.shipStatus);
  moreInfomation: string;
  options = YesNoOptions;
  yesNoOptionKeys = Object.keys(this.options);
  shipGasType = ShipGasType;
  imoCII = IMOCII;
  imoCIIKeys = Object.keys(this.imoCII);
  shipGasTypeKeys = Object.keys(this.shipGasType);
  displayedLang: any;
  OtherVesselType = AppConfig.settings.apiServer.OtherVesselType;

  OtherShimpentType = AppConfig.settings.apiServer.OtheShipmentType;
  OtherMilitaryType = AppConfig.settings.apiServer.OtherMilitaryType;
  OtherFuelType = AppConfig.settings.apiServer.OtherFuelType;

  PassengerShips = AppConfig.settings.apiServer.PassengerShips;
  public Languages: any = Languages;
  showPassengers: boolean = false;
  shipStatuses: any;
  showShipmentOther: boolean = false;
  showMilitaryShipment: boolean = false;
  ShowFloors: boolean = false;
  showFloat: boolean = false;
  ShowRoof: boolean = false;
  ShowGas: boolean = false;
  user: User = new User();
  numberDecimalRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  numberRegex: any = /^[0-9]*$/;
  emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';
  showRequest = false;
  AttachmentType = AttachmentType.FeesEstimation
  error: any = { isError: false, errorMessage: '' };
  errorLastTransit: any = { isError: false, errorMessage: '' };
  feesRequestId: string;
  agentId: string = '';
  documentsProgress: number;
  documentsProgress0: number;
  documentsProgress1: number;
  documentsProgress2: number;
  documentsProgress3: number;
  documentsProgress4: number;
  documentsProgress5: number;
  documentsProgress6: number;
  documentsProgress7: number;
  documentsProgress8: number;
  documentsProgress9: number;
  currencyModel: GenericLookup = new GenericLookup();
  @Input() public RequestStatus: number;
  private responseObj: ResponseObject = new ResponseObject();
  @ViewChild('FeesTabs',{static: false}) FeesTabs: TabsetComponent;
  @ViewChild('feesEstimation',{static: false}) feesEstimationEle: ElementRef;
  @Input() IsAdminMode: boolean = false;
  //@ViewChild('tabTwoControls')tabOneControls: ElementRef;
  @ViewChild('tabTwoControls',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabThreeControls',{static: false}) tabThreeControls: ElementRef;
  @ViewChild('tabOneControls',{static: false}) childComp: AgentBasicInfoComponent;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  //@Output() Loaded =  new EventEmitter<string>();
  @Input() public AgentId: string;
  ServiceStatus = ServiceStatus;
  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  currenctAttachment: Attachment = new Attachment();
  EtaTimeReset = new Date();
  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;
  uploadFolder = AppConfig.settings.apiServer.EBookingUploadsFolder;
  isErrorMessage: boolean = false;
  public FloorsNumber: GenericLookup[] = [
    { Id: 1, NameEN: '0', NameAR: '٠' },
    { Id: 2, NameEN: '1', NameAR: '١' },
    { Id: 3, NameEN: '2', NameAR: '٢' },
    { Id: 4, NameEN: '3', NameAR: '٣' },
    { Id: 5, NameEN: '4', NameAR: '٤' },
    { Id: 6, NameEN: '5', NameAR: '٥' },
    { Id: 7, NameEN: '6', NameAR: '٦' },
    { Id: 8, NameEN: '7', NameAR: '٧' },
    { Id: 9, NameEN: '8', NameAR: '٨' },
    { Id: 10, NameEN: '9', NameAR: '٩' },
    { Id: 11, NameEN: '10', NameAR: '١٠' },
    { Id: 12, NameEN: '11', NameAR: '١١' },
    { Id: 13, NameEN: '12', NameAR: '١٢' },
  ];
  isLoaded: boolean = false;
  getAttachments: Attachment[] = [];
  isTabOneValid: boolean = false;
  isTabTwoValid: boolean = false;
  isTabOneSubmitted: boolean = false;
  isTabTwoSubmitted: boolean = false;
  loggedInUser: User = new User();
  today = new Date();
  validFees: boolean = false;
  hasTransit: boolean = false;
  DefaultDate = new Date();
  showMilitaryShipmentOther: boolean = false;
  isCompleted: boolean = false;
  showVesselOther: boolean = false;
  showAction: boolean = true;
  transitRequestId: string;
  TransitRequestNumber: string;
  feesEstRequestId: string;
  showHeader: boolean = false;
  showSubmit: boolean = false;
  showOtherFuelType: boolean = false;

  todayDate: Date = new Date();
  constructor(
    private formBuilder: FormBuilder,
    private lookupService: LookupService, private fileService: fileService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private feesEstimationService: FeesEstimationService,
    private alertService: AlertService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private agentSrv: AgentService, private baseRequestService: BaseRequestService, private router: Router, ) {

    this.loggedInUser = this.authSrevice.currentUserValue;
    this.user = this.authSrevice.currentUserValue;
    this.shipStatusKeys = this.shipStatusKeys.slice(this.shipStatusKeys.length / 2);
    this.yesNoOptionKeys = this.yesNoOptionKeys.slice(this.yesNoOptionKeys.length / 2);
    this.shipGasTypeKeys = this.shipGasTypeKeys.slice(this.shipGasTypeKeys.length / 2);
    this.imoCIIKeys = this.imoCIIKeys.slice(this.imoCIIKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage();

    if (localStorage.getItem('FeesEstRequestId') != undefined) {
      this.feesRequestId = localStorage.getItem('FeesEstRequestId');
      localStorage.removeItem('FeesEstRequestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.feesRequestId = history.state.data.requestId;

    }
    else {
      this.CheckCanApplyFees();
    }
    //this.feesRequestId = this.route.snapshot.params.Id;
    this.fuelTypesDropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'NameEN',
      selectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أختر الكل' : 'Select All',
      unSelectAllText: this.globalSrv.getLanguage() == Languages.Arabic ? 'أحذف الكل' : 'UnSelect All',
      allowSearchFilter: true,
      enableCheckAll: false,
    }
  }

  ngOnInit() {
    this.buildForm();
    if (this.feesRequestId) {
      this.getFeesRequest();

      if (!this.user.IsAdmin) {

        this.showHeader = true;
      }
      else {
        this.showHeader = false;
      }
      if (this.AgentId) {
        this.agentId = this.AgentId;
      }
    }

    else if (this.formMode == FormMode.Add) {

      this.getLookups();
    }
  }

  private getLookups() {
    this.lookupService.getSailDirections().subscribe(d => {
      if (d.Data) {
        this.directions = d.Data;
      }
    });
    this.lookupService.GetShipTypes().subscribe(d => {
      this.shipTypes = d.Data.filter(p => p.IsDeleted == false);
    });
    this.lookupService.GetPropellerTypes().subscribe(d => {
    this.PropellerTypes = d.Data.filter(p => p.IsDeleted == false);
    });
    this.lookupService.GetShipmentTypes().subscribe(d => {
      this.shipmentTypes = d.Data.filter(p => p.IsDeleted == false);
    });
    this.lookupService.GetMilitaryShipmentTypes().subscribe(d => {
      this.militaryTypes = d.Data.filter(p => p.IsDeleted == false);
    });

    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data.filter(p => p.IsDeleted == false);
    });
    this.lookupService.GetFuelTypes().subscribe(d => {
      this.fuelTypes = d.Data.filter(p => p.IsDeleted == false);
      if (this.formMode == FormMode.Edit) {
        this.selectedFuelTypes = this.fuelTypes.filter(ft => this.selectedFuelTypesIds?.includes(ft.Id));
      }
    });
  }
  private getLookupsWithDeleted() {
    this.lookupService.getSailDirections().subscribe(d => {
      this.directions = d.Data;
    });
    this.lookupService.GetShipTypes().subscribe(d => {
      this.shipTypes = d.Data;
    });
        this.lookupService.GetPropellerTypes().subscribe(d => {
      this.PropellerTypes = d.Data;
    });
    this.lookupService.GetShipmentTypes().subscribe(d => {
      this.shipmentTypes = d.Data;
    });
    this.lookupService.GetMilitaryShipmentTypes().subscribe(d => {
      this.militaryTypes = d.Data;
    });

    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data;
    });
    this.lookupService.GetFuelTypes().subscribe(d => {
      this.fuelTypes = d.Data;
      if (this.formMode == FormMode.Readonly) {
        this.selectedFuelTypes = this.fuelTypes.filter(ft => this.selectedFuelTypesIds?.includes(ft.Id));
      }
    });
  }
  buildForm() {
    this.feesEstimationForm = this.formBuilder.group({
      agentInfo: new FormControl(""),
      VesselName: ['', Validators.required],
      SCID: ['', Validators.required],
      IMONO: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern("^[0-9]{7,7}$")]],
      CallSign: ['', Validators.required],
      ShipTypeId: [null, Validators.required],
      IMOCII: [null, Validators.required],
      FuelTypeIds:['',Validators.required],
      FuelTypeOther: [''],
      VesselTypeOther: [''],
      DirectionId: ['', Validators.required],
      ShipStatus: ['', Validators.required],
      PropellerTypeId: ['', Validators.required],
      IsScrubberInstalled: ['', Validators.required],
      PassengersNumber: ['', [Validators.pattern(this.numberRegex)]],
      ShipmentTypeId: ['', Validators.required],
      ShipmentQuantity: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      IsMilitaryShip: ['', Validators.required],
      MilitaryShipmentTypeId: ['', Validators.required],
      MilitaryShipmentQuantity: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      IsRoofFloatingUnits: ['', Validators.required],
      TotalSuezAmount: [''],
      FloatingUnitHeight: [''],
      FloatingUnitWidth: [''],
      FloatingUnitLength: [''],
      IsEmptyConatiners: ['', Validators.required],
      FloorsNumber: ['', [Validators.pattern(this.numberRegex)]],
      IsRoofContainers: ['', Validators.required],
      RoofContainerFloorsNumber: ['', Validators.required],
      IsGasShip: ['', Validators.required],
      GasType: [''],
      GazAmount: ['', Validators.pattern(this.numberDecimalRegex)],
      ShipNationalityId: ['', Validators.required],
      Height: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      Width: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      TotalSuezCanalAmout: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      SuezCanalNetTonnage: ['', [Validators.required, Validators.pattern(this.numberDecimalRegex)]],
      ETA: ['', [Validators.required, CustomValidators.dateValidator()]],
      ETATime: [new Date(), Validators.required],
      ArrivalDate: [''],
      TransitDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      LastTransitDate: [''],
      GraveMaterial: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      SubmersibleAccess: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      Flake: [''],
      Scouts: [''],
      ComingFrom: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      DestinedTo: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      TermsAndConditions: [false, [Validators.requiredTrue]],
      ShipmentOther: [''],
      MilitaryShipmentOther: [''],
      ContainerReduction: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      PrincipalName: ['', [Validators.required, Validators.maxLength(250),CustomValidators.textSpaceValidator()]],
      PrincipalEMail: ['', [Validators.required, Validators.pattern(this.emailRegex), Validators.maxLength(150),CustomValidators.textSpaceValidator()]],
      PrincipalFax: ['', [Validators.pattern(this.numberRegex)]],
      Attachments: this.formBuilder.array([]),
    });
    if (!this.feesRequestId) {
      this.addAttachments();
    }
  }

  get f() {
    return this.feesEstimationForm.controls;
  }

  get getFeesEstimationAttachmentsGetter() {
    return this.feesEstimationForm.controls["Attachments"].value;
  }

  get getFeesEstimationAttachmentsLengthGetter() {
    return this.getFeesEstimationAttachmentsGetter.length;
  }

  //#region CVA starts

  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.feesEstimationForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.feesEstimationForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.feesEstimationForm.disable() : this.feesEstimationForm.enable();
  }
  registerOnValidatorChange(fn: () => void): void {
    this.feesEstimationForm.statusChanges.subscribe(fn);
  }
  validate(c: AbstractControl): ValidationErrors | null {
    //return this.agentForm.valid ? null : { invalidForm: {valid: false, message: "agent form fields are invalid"}};
    return this.feesEstimationForm.valid ? null : this.feesEstimationForm.controls;
  }
  //#endregion

  addAttachments() {

    let control = <FormArray>this.feesEstimationForm.controls['Attachments'];
    control.push(new FormGroup({
      DocumentName: new FormControl('', Validators.required),
      URL: new FormControl('', FileValidator.validate),
      AttachmentTypeId: new FormControl(''),
      Id: new FormControl('')
    }));
    return control;
  }


  receiveCurrency($event) {
    this.currencyId = $event
  }
  receiveTabOneValidity($event) {

    this.isTabOneValid = $event
  }

  fuelTypesChanged() {
    const fuelTypeOther = this.feesEstimationForm.get("FuelTypeOther") as FormControl;
    if (this.selectedFuelTypes && this.selectedFuelTypes.find(x => x.NameEN == 'Other')) {
      this.showOtherFuelType = true;
      fuelTypeOther.setValidators([Validators.required]);
      fuelTypeOther.updateValueAndValidity();
    }
    else {
      this.showOtherFuelType = false;
      fuelTypeOther.clearValidators();
      fuelTypeOther.updateValueAndValidity();
    }
  }


  onSubmit() {

    // nashwa validation focus
    // const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
    // if (invalidElements.length > 0) {
    //   invalidElements[0].focus();

    // }
    const invalidElements = this.feesEstimationEle.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      if (!this.isTabTwoValid) {
        invalidElements[0].focus();
        this.navigateToTab(1);
      }
      else if (!this.getValidity()) {
        invalidElements[0].focus();
        this.navigateToTab(2);
      }

    }

    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.feesEstimationForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.feesEstimationForm.get("ETA").value) {
      var selectedDate = this.feesEstimationForm.get("ETA").value.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
      var selectedTime = this.feesEstimationForm.get("ETATime").value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
      var fullDate = selectedDate + ", " + selectedTime;
      this.feesEstimationForm.controls['ArrivalDate'].setValue(fullDate);
    }
    let dateNow = new Date();
    if (this.feesEstimationForm.get("TransitDate").value) {
      var selectedTransitDate = this.feesEstimationForm.get("TransitDate").value.toLocaleString('en-US');
      this.feesEstimationForm.controls['TransitDate'].setValue(selectedTransitDate);
    }
    if (this.feesEstimationForm.get("LastTransitDate").value) {
      var selectedLastDate = this.feesEstimationForm.get("LastTransitDate").value.toLocaleString('en-US');
      this.feesEstimationForm.controls['LastTransitDate'].setValue(selectedLastDate);
    }
    const fuelTypeIdsString = this.feesEstimationForm.get('FuelTypeIds').value.map(ft => ft.Id).join(',');

    this.loading = true;

    this.feesEstimate = this.feesEstimationForm.value;
    this.feesEstimate.SelectedCurrencyId = this.currencyId;
    this.feesEstimate.FuelTypeIds = fuelTypeIdsString;
    this.feesEstimate.RequestorId = this.user.UserId;
    if (this.formMode == FormMode.Add) {
      this.feesEstimationService.add(this.feesEstimate).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'), false);
              this.feesEstimationForm.reset();
              this.loading = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
              this.loading = false;
            }

          });
    }
    if (this.formMode == FormMode.Edit) {
      this.feesEstimate.Id = this.feesRequestId;
      this.getAttachments = this.feesEstimationForm.value.Attachments;
      this.getAttachments.forEach((form) => {
        this.RequestAttachments.forEach((db) => {
          if (form.Id == db.Id && form.URL == null) {
            form.URL = db.URL;
          }
        });
      });
      this.feesEstimationService.Update(this.feesEstimate).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGES.ADD_SUCCESSFULLY'), false);
              this.feesEstimationForm.reset();
              this.loading = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
              this.loading = false;
            }

          });
    }
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }


  bindAttachments(attachments): any {
    let control = <FormArray>this.feesEstimationForm.controls['Attachments'];
    if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent && !this.loggedInUser.IsAdmin) {
      attachments.forEach((key) => {
        control.push(new FormGroup({
          DocumentName: new FormControl({ value: key.DocumentName, disabled: false }),
          //URL: new FormControl({ value: '', disabled: false }),
          URL: new FormControl(),
          AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false }),
        }));
      });
    }
    else {
      attachments.forEach((key) => {
        control.push(new FormGroup({
          DocumentName: new FormControl({ value: key.DocumentName, disabled: true }),
          //URL: new FormControl({ value: '', disabled: true }),
          URL: new FormControl(),
          AttachmentTypeId: new FormControl({ value: key.AttachmentTypeId, disabled: false }),
          Id: new FormControl({ value: key.Id, disabled: false })
        }));
      });
    }
    return control;
  }


  getCurrentAttchment(index) {
    if (this.RequestAttachments.length > 0) {
      this.currenctAttachment = this.RequestAttachments[index];
    }
  }


  public onFileSelected(event, currFormControl, index, progressVariableName) {
    // console.log("uploader" + event);
    this[progressVariableName] = 0;
    let percentDone = 0;
    this.alertService.clear();
    // progressVariableName=0;
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let donName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', donName);
      formData.append('FolderName', this.uploadFolder); //New Line


      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            percentDone = Math.round(100 * event.loaded / event.total)

            //console.log(`File is ${percentDone}% uploaded.`);

            this[progressVariableName] = percentDone;
            currFormControl.setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {
            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            currFormControl.setValue(Url);
            currFormControl.setErrors(null);
            currFormControl.updateValueAndValidity();
          }
        }

      );
    }

  }
 ngAfterViewInit() {

    if (this.FeesTabs?.tabs?.length > 0)

    this.FeesTabs.tabs[1].disabled = true;
    this.FeesTabs.tabs[2].disabled = true;
    this.cd.detectChanges();
  }


  getValidity() {
    let controls = this.feesEstimationForm.get('Attachments') as FormArray;
    return !controls.invalid;

  }

  get Attachments() {
    return this.feesEstimationForm.get('Attachments') as FormArray;
  }


  get attachment(): FormGroup {
    return this.formBuilder.group({
      DocumentName: '',
      URL: '',
      AttachmentTypeId: ''
    });
  }

  selectTab(tabId: number) {
    if (tabId == 2) {
      this.isTabTwoSubmitted = true;
      if (!this.ValidateTabTwo) {
        this.isTabTwoValid = true;
        this.FeesTabs.tabs[tabId].disabled = false;
        this.FeesTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        const invalidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }
    }
    else {
      this.FeesTabs.tabs[tabId].disabled = false;
      this.FeesTabs.tabs[tabId].active = true;
    }
  }

  get ValidateTabTwo() {
    const isvalid = this.feesEstimationForm.controls['VesselName'].invalid
      || this.feesEstimationForm.controls['IMONO'].invalid
      || this.feesEstimationForm.controls['SCID'].invalid
      || this.feesEstimationForm.controls['CallSign'].invalid
      || (this.feesEstimationForm.controls['ShipTypeId'].invalid
      || this.feesEstimationForm.controls['ShipTypeId'].value == 'null')
      || this.feesEstimationForm.controls['IMOCII'].invalid
      || (this.feesEstimationForm.controls['FuelTypeIds'].invalid
      ||  this.selectedFuelTypes.length < 1)
      || this.feesEstimationForm.controls['FuelTypeOther'].invalid
      || this.feesEstimationForm.controls['VesselTypeOther'].invalid
      || this.feesEstimationForm.controls['FuelTypeOther'].invalid
      || this.feesEstimationForm.controls['DirectionId'].invalid
      || this.feesEstimationForm.controls['ShipStatus'].invalid
      || this.feesEstimationForm.controls['PropellerTypeId'].invalid
      || this.feesEstimationForm.controls['IsScrubberInstalled'].invalid
      || this.feesEstimationForm.controls['PassengersNumber'].invalid

      || this.feesEstimationForm.controls['ShipmentTypeId'].invalid
      || this.feesEstimationForm.controls['ShipmentQuantity'].invalid
      || this.feesEstimationForm.controls['ShipmentOther'].invalid

      || this.feesEstimationForm.controls['IsMilitaryShip'].invalid
      || this.feesEstimationForm.controls['MilitaryShipmentTypeId'].invalid
      || this.feesEstimationForm.controls['MilitaryShipmentQuantity'].invalid
      || this.feesEstimationForm.controls['MilitaryShipmentOther'].invalid

      || this.feesEstimationForm.controls['IsRoofFloatingUnits'].invalid
      || this.feesEstimationForm.controls['TotalSuezAmount'].invalid
      || this.feesEstimationForm.controls['FloatingUnitHeight'].invalid
      || this.feesEstimationForm.controls['FloatingUnitWidth'].invalid
      || this.feesEstimationForm.controls['FloatingUnitLength'].invalid

      || this.feesEstimationForm.controls['IsEmptyConatiners'].invalid
      || this.feesEstimationForm.controls['FloorsNumber'].invalid

      || this.feesEstimationForm.controls['IsRoofContainers'].invalid
      || this.feesEstimationForm.controls['RoofContainerFloorsNumber'].invalid

      || this.feesEstimationForm.controls['IsGasShip'].invalid
      || this.feesEstimationForm.controls['GasType'].invalid
      || this.feesEstimationForm.controls['GazAmount'].invalid

      || this.feesEstimationForm.controls['ShipNationalityId'].invalid
      || this.feesEstimationForm.controls['Height'].invalid
      || this.feesEstimationForm.controls['Width'].invalid
      || this.feesEstimationForm.controls['TotalSuezCanalAmout'].invalid
      || this.feesEstimationForm.controls['SuezCanalNetTonnage'].invalid
      || this.feesEstimationForm.controls['ETA'].invalid

      || this.feesEstimationForm.controls['TransitDate'].invalid
      || this.feesEstimationForm.controls['LastTransitDate'].invalid
      || this.feesEstimationForm.controls['GraveMaterial'].invalid
      || this.feesEstimationForm.controls['SubmersibleAccess'].invalid

      || this.feesEstimationForm.controls['ComingFrom'].invalid
      || this.feesEstimationForm.controls['DestinedTo'].invalid

      || this.feesEstimationForm.controls['ContainerReduction'].invalid

      || this.feesEstimationForm.controls['PrincipalName'].invalid
      || this.feesEstimationForm.controls['PrincipalEMail'].invalid
      || this.feesEstimationForm.controls['PrincipalFax'].invalid ;
    if (isvalid) {
      this.isTabTwoValid = false;
    }
    else {
      this.isTabTwoValid = true;
    }


    return isvalid;
  }

  ChangingShip(event) {
    const vesselTypeId = this.feesEstimationForm.get('VesselTypeOther');
    this.shipType = event.target.value;
    const shipStatus = this.feesEstimationForm.get('ShipStatus');
    const passengersNumber = this.feesEstimationForm.get('PassengersNumber');
    if ((this.shipType == this.PassengerShips && this.shipStatuses == ShipStatus.Loaded) ||
      this.shipType != this.PassengerShips && (shipStatus.value == ShipStatus.Ballast || shipStatus.value == ShipStatus.Loaded)) {
      this.showPassengers = true;
    } else {
      this.showPassengers = false;
      passengersNumber.clearValidators();
      passengersNumber.updateValueAndValidity();
    }

    if (this.shipType === this.OtherVesselType) {
      this.showVesselOther = true;
      vesselTypeId.setValidators([Validators.required]);
      vesselTypeId.updateValueAndValidity();
    }
    else {
      this.showVesselOther = false;
      vesselTypeId.clearValidators();
      vesselTypeId.updateValueAndValidity();
    }
  }

  changeStatus(status) {

    this.shipStatuses = status;
    const passengersNumber = this.feesEstimationForm.get('PassengersNumber');
    const ShipTypeId = this.feesEstimationForm.get('ShipTypeId');
    if ((ShipTypeId.value == this.PassengerShips && this.shipStatuses == ShipStatus.Loaded) ||
      (ShipTypeId.value != this.PassengerShips && (this.shipStatuses == ShipStatus.Ballast || this.shipStatuses == ShipStatus.Loaded))) {
      this.showPassengers = true;
      passengersNumber.setValidators([Validators.required, Validators.pattern(this.numberRegex)]);
      passengersNumber.updateValueAndValidity();
    }
    else {
      this.showPassengers = false;
      passengersNumber.clearValidators();
      passengersNumber.updateValueAndValidity();
    }
  }

  ChangingShipment(event) {
    const shipmentOther = this.feesEstimationForm.get('ShipmentOther');
    let shipment = event.target.value;
    if (shipment === this.OtherShimpentType) {
      this.showShipmentOther = true;
      shipmentOther.setValidators([Validators.required, CustomValidators.textSpaceValidator()]);
      shipmentOther.updateValueAndValidity();
    }
    else {
      this.showShipmentOther = false;
      shipmentOther.clearValidators();
      shipmentOther.updateValueAndValidity();
    }
  }


  ChangingOtherMilitary(event) {
    const MilitaryShipmentOther = this.feesEstimationForm.get('MilitaryShipmentOther');
    let shipment = event.target.value;
    if (shipment === this.OtherMilitaryType) {
      this.showMilitaryShipmentOther = true;
      MilitaryShipmentOther.setValidators([Validators.required, CustomValidators.textSpaceValidator()]);
      MilitaryShipmentOther.updateValueAndValidity();
    }
    else {
      MilitaryShipmentOther.clearValidators();
      MilitaryShipmentOther.updateValueAndValidity();
      this.showMilitaryShipmentOther = false;
    }
  }

  // changeMilitary(event) {

  //   let military = event;
  //   if (military == YesNoOptions.Yes) {
  //     this.showMilitaryShipment = true;
  //   }
  //   else {
  //     this.showMilitaryShipment = false;
  //     this.showMilitaryShipmentOther = false;
  //     const MilitaryShipmentOther = this.feesEstimationForm.get('MilitaryShipmentOther');
  //     MilitaryShipmentOther.clearValidators();
  //     MilitaryShipmentOther.updateValueAndValidity();

  //   }
  // }

  changeFloating(event) {

    let float = event;
    const TotalSuezAmount = this.feesEstimationForm.get('TotalSuezAmount');
    const FloatingUnitHeight = this.feesEstimationForm.get('FloatingUnitHeight');
    const FloatingUnitWidth = this.feesEstimationForm.get('FloatingUnitWidth');
    const FloatingUnitLength = this.feesEstimationForm.get('FloatingUnitLength');
    if (float == YesNoOptions.Yes) {
      this.showFloat = true;
      TotalSuezAmount.setValidators([Validators.required]);
      TotalSuezAmount.updateValueAndValidity();
      FloatingUnitHeight.setValidators([Validators.required]);
      FloatingUnitHeight.updateValueAndValidity();
      FloatingUnitWidth.setValidators([Validators.required]);
      FloatingUnitWidth.updateValueAndValidity();
      FloatingUnitLength.setValidators([Validators.required]);
      FloatingUnitLength.updateValueAndValidity();
    }
    else {
      this.showFloat = false;
      TotalSuezAmount.clearValidators();
      TotalSuezAmount.updateValueAndValidity();
      FloatingUnitHeight.clearValidators();
      FloatingUnitHeight.updateValueAndValidity();
      FloatingUnitWidth.clearValidators();
      FloatingUnitWidth.updateValueAndValidity();
      FloatingUnitLength.clearValidators();
      FloatingUnitLength.updateValueAndValidity();
    }
  }


  changeEmpty(event) {

    let empty = event;
    const FloorsNumber = this.feesEstimationForm.get('FloorsNumber');
    if (empty == YesNoOptions.Yes) {
      this.ShowFloors = true;
      FloorsNumber.setValidators([Validators.required, Validators.pattern(this.numberRegex)]);
      FloorsNumber.updateValueAndValidity();
    }
    else {
      this.ShowFloors = false;
      FloorsNumber.clearValidators();
      FloorsNumber.updateValueAndValidity();
    }
  }

  changeRoof(event) {

    let roof = event;
    if (roof == YesNoOptions.Yes) {
      this.ShowRoof = true;
    }
    else this.ShowRoof = false;
  }

  changeGasShip(event) {

    let Gas = event;
    const GasType = this.feesEstimationForm.get('GasType');
    const GazAmount = this.feesEstimationForm.get('GazAmount');
    if (Gas == ShipGasType.NotGasFree) {
      this.ShowGas = true;
      GasType.setValidators([Validators.required]);
      GasType.updateValueAndValidity();
      GazAmount.setValidators([Validators.required, Validators.pattern(this.numberDecimalRegex)]);
      GazAmount.updateValueAndValidity();
    }
    else {
      this.ShowGas = false;
      GasType.clearValidators();
      GasType.updateValueAndValidity();
      GazAmount.clearValidators();
      GazAmount.updateValueAndValidity();
    }

  }

  deleteAttachments(index: number, progressVariableName) {
    this[progressVariableName] = 0;
    this.Attachments.removeAt(index);
    this.RequestAttachments.splice(index, 1);

  }

  compareTwoDates() {
    if (this.formMode != FormMode.Readonly) {
      if ((this.feesEstimationForm.controls['ETA'].value && this.feesEstimationForm.controls['TransitDate'].value) &&
        new Date(this.feesEstimationForm.controls['TransitDate'].value) < new Date(this.feesEstimationForm.controls['ETA'].value)) {
        this.error = { isError: true, errorMessage: this.translate.instant('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_DATES_ERROR') };
        this.feesEstimationForm.controls['ETA'].setErrors({ 'invalid': true });
      }
      else {
        this.error = { isError: false, errorMessage: '' };
        this.feesEstimationForm.get('ETA').setValidators([Validators.required, CustomValidators.dateValidator]);
        this.feesEstimationForm.get('ETA').updateValueAndValidity();
      }
    }
  }

  compareLastTransit() {
    if (this.formMode != FormMode.Readonly) {

      if ( this.feesEstimationForm.controls['LastTransitDate'].value== "Invalid Date") {
        this.feesEstimationForm.controls['LastTransitDate'].setErrors({ 'invalid': true });
      }

      else if ((this.feesEstimationForm.controls['ETA'].value && this.feesEstimationForm.controls['TransitDate'].value && this.feesEstimationForm.controls['LastTransitDate'].value) &&
        ((new Date(this.feesEstimationForm.controls['TransitDate'].value) < new Date(this.feesEstimationForm.controls['LastTransitDate'].value)) &&
          (new Date(this.feesEstimationForm.controls['ETA'].value) < new Date(this.feesEstimationForm.controls['LastTransitDate'].value)))) {
        this.errorLastTransit = { isError: true, errorMessage: this.translate.instant('FRONT_USER.FEES_ESTIMATION_FORM.COMPARE_LAST_TRANSIT_ERROR') };
        this.feesEstimationForm.controls['LastTransitDate'].setErrors({ 'invalid': true });
      }
      else {
        this.errorLastTransit = { isError: false, errorMessage: '' };
        this.feesEstimationForm.get('LastTransitDate').clearValidators();
        this.feesEstimationForm.get('LastTransitDate').updateValueAndValidity();
      }
    }

  }


  public getFeesRequest() {
    this.feesEstimationService.get(this.feesRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {

        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.isTabOneValid = true;
          this.isTabTwoValid = true;

          this.requestStatus = resObj.Data['StatusId'];
          this.isLoaded = true;
          this.getbaseRequest();

          this.moreInfomation = resObj.Data['MoreInformation']
          if (resObj.Data['ExpirationDate'] && new Date(resObj.Data['ExpirationDate']) >= this.today) {
            this.validFees = true;
          }
          //this.Loaded.emit( this.agentId);
          this.agentId = resObj.Data['RequestorId'];
          if (history.state.data && history.state.data.isCompleted) {
            this.feesEstimationForm.disable();
            this.feesEstimationForm.get('FuelTypeIds').disable();
            this.formMode = FormMode.Readonly;
            this.showAction = false;
            if (this.moreInfomation) {
              this.isCompleted = true;
            }
          }
          else if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent && !this.loggedInUser.IsAdmin) {
            this.feesEstimationForm.enable();
            this.showSubmit = true;
            this.formMode = FormMode.Edit;
          }

          else {
            this.feesEstimationForm.disable();
            this.feesEstimationForm.get('FuelTypeIds').disable();
            this.formMode = FormMode.Readonly;
          }
          // if (this.formMode == FormMode.Readonly || this.formMode == FormMode.Edit) {
          //   this.FeesTabs.tabs[1].disabled = false;
          //   this.FeesTabs.tabs[2].disabled = false;
          // }
          if (this.moreInfomation && this.loggedInUser.IsAdmin && this.requestStatus == ServiceStatus.PendingonMeasurementsOfficerReviewerApproval) {
            this.isCompleted = true;
          }
          // this.agentSrv.filter(this.agentId);
          this.selectedFuelTypesIds = this.responseObj.Data['FuelTypeIds']?.split(',').map(id => parseInt(id));
          this.RequestAttachments = resObj.Data['Attachments'];
          this.feesEstimationForm.setControl('Attachments', this.bindAttachments(this.RequestAttachments));
          //// to ignore binding the file input "URL"
          resObj.Data['Attachments'] = [];
          resObj.Data['FuelTypeIds'] = "";

          if (this.formMode == FormMode.Readonly) {
            this.getLookupsWithDeleted();
          } else if (this.formMode == FormMode.Edit) {
            this.getLookups();
          }

          if (this.responseObj.Data['ShipTypeId'] == this.OtherVesselType) {
            this.showVesselOther = true;
          }

          if (this.responseObj.Data['ShipmentTypeId'] == this.OtherShimpentType) {
            this.showShipmentOther = true;
          }
          if (this.responseObj.Data['FuelTypeIds'].includes(this.OtherFuelType)) {
            this.showOtherFuelType = true;
          }
          if ((this.responseObj.Data['ShipTypeId'] == this.PassengerShips && this.responseObj.Data['ShipStatus'] == ShipStatus.Loaded) ||
            (this.responseObj.Data['ShipTypeId'] != this.PassengerShips && (this.responseObj.Data['ShipStatus'] == ShipStatus.Ballast || this.responseObj.Data['ShipStatus'] == ShipStatus.Loaded))) {
            this.showPassengers = true;
          }
          if (this.responseObj.Data['MilitaryShipmentTypeId'] == this.OtherMilitaryType) {
            this.showMilitaryShipmentOther = true;
          }
          // if (this.responseObj.Data['IsRoofContainers']) {
          //   this.ShowRoof = true;
          this.responseObj.Data['RoofContainerFloorsNumber'] = this.responseObj.Data['RoofContainerFloorsNumber'].trim();
          this.feesEstimationForm.controls['RoofContainerFloorsNumber'].setValue(this.responseObj.Data['RoofContainerFloorsNumber']);
          // }
          if (this.responseObj.Data['IsGasShip']) {
            this.ShowGas = true;
          }
          if (this.responseObj.Data['IsEmptyConatiners']) {
            this.ShowFloors = true;
          }
          if (this.responseObj.Data['IsRoofFloatingUnits']) {
            this.showFloat = true;
          }
          this.responseObj.Data['IsEmptyConatiners'] = this.responseObj.Data['IsEmptyConatiners'] ? 1 : 0;
          this.responseObj.Data['IsGasShip'] = this.responseObj.Data['IsGasShip'] ? 1 : 0;
          this.responseObj.Data['IsMilitaryShip'] = this.responseObj.Data['IsMilitaryShip'] ? 1 : 0;
          this.responseObj.Data['IsRoofContainers'] = this.responseObj.Data['IsRoofContainers'] ? 1 : 0;
          this.responseObj.Data['IsRoofFloatingUnits'] = this.responseObj.Data['IsRoofFloatingUnits'] ? 1 : 0;
          this.responseObj.Data['IsScrubberInstalled'] = this.responseObj.Data['IsScrubberInstalled'] ? 1 : 0;
          if (this.formMode == FormMode.Edit) {
            // console.log(this.selectedFuelTypesIds);
            // console.log(this.fuelTypes);
            // this.selectedFuelTypes = this.fuelTypes.filter(ft => this.selectedFuelTypesIds.includes(ft.Id));
            // console.log(this.selectedFuelTypes);

          }



          this.currencyId = resObj.Data['SelectedCurrencyId']

          this.feesEstimationForm.patchValue(resObj.Data);

          if (resObj.Data['TransitDate']) {
            this.feesEstimationForm.patchValue({
              TransitDate: new Date(resObj.Data['TransitDate']),
            });
          }
          if (resObj.Data['LastTransitDate']) {
            this.feesEstimationForm.patchValue({
              LastTransitDate: new Date(resObj.Data['LastTransitDate']),
            });
          }
          if (resObj.Data['ArrivalDate']) {
            this.feesEstimationForm.patchValue({
              TermsAndConditions: true,
              ETA: new Date(resObj.Data['ArrivalDate']),
              ETATime: new Date(resObj.Data['ArrivalDate']),

            });
          } else {
            this.feesEstimationForm.patchValue({
              TermsAndConditions: true,
              ETATime: Date
            });
          }

        }
      });

  }

  public getbaseRequest() {
    this.baseRequestService.getBaseRequest(this.feesRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.baseRequestService.GetByParentRequestId(this.feesRequestId, Service.TransitRequest).subscribe(
          d => {
            if (d.Data) {
              this.hasTransit = true;
              this.TransitRequestNumber = d.Data.RequestNumber;
            } else {
              this.hasTransit = false;
            }

          });

      });
  }

  getTransitByParentId() {
    this.baseRequestService.GetByParentRequestId(this.feesRequestId, Service.TransitRequest).subscribe(
      d => {
        if (d.Success) {

          this.transitRequestId = d.Data["Id"];
          // let requestId = this.transitRequestId;
          // const navigationExtras: NavigationExtras = { state: { data: { requestId } } };
          // this.router.navigate(['/transitRequest'], navigationExtras);

          localStorage.setItem('TransitRequestId', this.transitRequestId);
          window.open('#/transitRequest', '_blank');
        }
      });
  }

  applyTransitRequest(): void {
    localStorage.setItem('FeesRequestId', this.feesRequestId);
    window.open('#/transitRequest', '_blank');
  }
  navigateToTab(tabId: number) {
    this.FeesTabs.tabs[tabId].disabled = false;
    this.FeesTabs.tabs[tabId].active = true;
  }


  goToTermsAndCond(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.EBookingTermsAR, '_blank');
    else
      window.open(AppConfig.settings.apiServer.EBookingTermsEN, '_blank');
  }

  CheckCanApplyFees() {
    this.agentSrv.CanApplyFeesRequest(this.loggedInUser.UserName).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (!data.Success) {
            this.router.navigate(['/unAuhtorized']);
          }
        });
  }

  get validateSubmitButton() {

    if (this.isTabOneValid && this.isTabTwoValid) {
      if (this.FeesTabs.tabs[2].disabled == false &&
        this.FeesTabs.tabs[2].active == true) {
        this.showSubmit = true;
      }

    }
    return this.showSubmit;
  }
}


